import { Link } from "react-router-dom";
import { ArrowRight, Clock, Loader2 } from "lucide-react";
import { PageHero, CTABand } from "../components/sections";
import { Stagger, StaggerItem } from "../components/Reveal";
import { IMAGES } from "../data/site";
import { useBlogs } from "../hooks/useBlogs";

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" }) : "");

export default function Blog() {
  const { data: posts = [], isLoading } = useBlogs();
  const [featured, ...rest] = posts;

  return (
    <div>
      <PageHero eyebrow="Travel Stories" title="Journal & travel tips" subtitle="Destination guides, planning tips and stories from 35+ years on the road — from the Life Line team." image={IMAGES.nepal} />

      <section className="ll-container py-16" data-testid="blog-listing">
        {isLoading ? (
          <div className="py-24 flex justify-center"><Loader2 className="animate-spin text-[#4ef72d]" size={32} /></div>
        ) : posts.length === 0 ? (
          <p className="py-24 text-center text-[#4A5D58]">No stories published yet. Check back soon.</p>
        ) : (
          <>
            {/* Featured */}
            {featured && (
              <Link to={`/blog/${featured.slug}`} data-testid={`blog-featured-${featured.slug}`} className="ll-card group grid md:grid-cols-2 overflow-hidden mb-16">
                <div className="relative h-72 md:h-full overflow-hidden">
                  <img src={featured.image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms] ease-out" />
                  <span className="absolute top-5 left-5 badge-dark">{featured.category}</span>
                </div>
                <div className="p-8 md:p-12 flex flex-col justify-center">
                  <p className="text-sm text-[#4A5D58] flex items-center gap-2"><Clock size={14} /> {fmtDate(featured.date)} · {featured.read_time}</p>
                  <h2 className="font-display text-3xl md:text-4xl font-bold mt-3 leading-tight group-hover:text-[#4ef72d] transition-colors">{featured.title}</h2>
                  <p className="text-[#4A5D58] text-lg mt-4 leading-relaxed">{featured.excerpt}</p>
                  <span className="inline-flex items-center gap-2 mt-6 font-semibold text-[#0A221C]">Read Story <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" /></span>
                </div>
              </Link>
            )}

            {/* Grid */}
            <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {rest.map((post) => (
                <StaggerItem key={post.slug}>
                  <Link to={`/blog/${post.slug}`} data-testid={`blog-card-${post.slug}`} className="ll-card group block h-full">
                    <div className="relative h-56 overflow-hidden">
                      <img src={post.image} alt={post.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms] ease-out" />
                      <span className="absolute top-4 left-4 badge-dark">{post.category}</span>
                    </div>
                    <div className="p-6">
                      <p className="text-xs text-[#4A5D58]">{fmtDate(post.date)} · {post.read_time}</p>
                      <h3 className="font-display text-xl font-bold text-[#0A221C] mt-2 leading-snug group-hover:text-[#4ef72d] transition-colors">{post.title}</h3>
                      <p className="text-[#4A5D58] text-sm mt-3 line-clamp-3">{post.excerpt}</p>
                    </div>
                  </Link>
                </StaggerItem>
              ))}
            </Stagger>
          </>
        )}
      </section>

      <div className="pb-24"><CTABand /></div>
    </div>
  );
}
